<div class="holder">
    <div style="width:100%;"><img src="assets/img/arteswhite.png" style="width:30%;"></div>
    <img [@fadeInOut]="simply" class="letter" src="assets/img/simply.png">
    <img [@fadeInOut]="beyond" class="letter" src="assets/img/beyond.png">
    <img [@fadeInOut]="go" class="letter" src="assets/img/go.png">
</div>
